import axios from "@/libs/api.request";

export const getOriPack = (data) => {
  return axios.request({
    url: `/warehouse/transferOnlineList`,
    method: "post",
    data,
  });
};

export const getPackWare = () => {
  return axios.request({
    url: `/overseaOrder/getTransferPutShelfWarehouse`,
    method: "get",
  });
};

export const postAdd = (data) => {
  return axios.request({
    url: `/overseaOrder/transferPutShelf`,
    method: "post",
    data,
  });
};

export const postDown = (data) => {
  return axios.request({
    url: `/overseaOrder/transferOffShelf`,
    method: "post",
    data,
  });
};

// 虚拟仓操作
export const getVirtual = (data) => {
  return axios.request({
    url: `/warehouse/addTransferPlan`,
    method: "post",
    data,
  });
};

// 虚拟仓修改状态
export const getVirtualStatus = (data) => {
  return axios.request({
    url: `/warehouse/updateTransferStatus`,
    method: "post",
    data,
  });
};

// 虚拟仓修改代理状态
export const getVirtualAgentStatus = (data) => {
  return axios.request({
    url: `/warehouse/updateStatusAgent`,
    method: "post",
    data,
  });
};
